/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class JiraDataCenterBudgetAlertMapping extends models.JiraDataCenterMappingBase {
    getFixupPrototypeFunction() { return JiraDataCenterBudgetAlertMapping.fixupPrototype; }

    static newInstance(model: Partial<JiraDataCenterBudgetAlertMapping>): JiraDataCenterBudgetAlertMapping {
        let obj = Object.assign(new JiraDataCenterBudgetAlertMapping(), model);
        JiraDataCenterBudgetAlertMapping.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<JiraDataCenterBudgetAlertMapping>): JiraDataCenterBudgetAlertMapping {
        if (!model) return null;
        return JiraDataCenterBudgetAlertMapping.newInstance(<JiraDataCenterBudgetAlertMapping> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: JiraDataCenterBudgetAlertMapping) {
        if (!obj) return;

        models.JiraDataCenterBudgetAlertMapping.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: JiraDataCenterBudgetAlertMapping): boolean {
        if (models.JiraDataCenterMappingBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, JiraDataCenterBudgetAlertMapping.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.issue_type) {
            models.JiraDataCenterIssueType.fixupPrototype(this.issue_type);
        }
    }

    /**
     * IssueType attribute mapping for JIRA DataCenter
     */
    issue_type: models.JiraDataCenterIssueType;

    selected_description_attributes: Array<models.JiraDataCenterBudgetAlertDescriptionAttribute>;

}
